// extracted by mini-css-extract-plugin
module.exports = {"asideItem":"_-ui-admin-lib-AsideItem-index-module__asideItem--3G618","activated":"_-ui-admin-lib-AsideItem-index-module__activated--2FK-p"};